module.exports = __webpack_public_path__ + "front/img/c12.aafb4ada.png";